export const API_URL = window.REACT_APP_API_URL || process.env.REACT_APP_API_URL

export const fetchOptions = ({ session, body, ...options }) => {
	try {
		session =
			session ||
			localStorage.getItem('session-token') ||
			sessionStorage.getItem('session-token')
	} catch (_) {}
	const headers = {
		Authorization: session ? `Bearer ${session}` : undefined,
	}
	if (body && !(body instanceof FormData)) {
		headers['Content-Type'] = 'application/json'
	}
	return {
		headers,
		credentials: 'same-origin',
		mode: 'cors',
		body: body
			? body instanceof FormData
				? body
				: JSON.stringify(body)
			: undefined,
		...(options || {}),
	}
}

export const parseJSONContent = async (r) => {
	if (r.status >= 400) {
		return new Promise((_, reject) => {
			const contentType = r.headers.get('Content-Type')
			if (contentType && contentType.indexOf('application/json') !== -1) {
				r.json().then((result) =>
					reject({ ...result, status: r.status || result.status })
				)
			} else {
				r.text().then((res) =>
					reject({
						status: r?.status,
						message: res || 'Unknown error',
					})
				)
			}
		})
	}
	const contentType = r.headers.get('Content-Type')
	if (contentType && contentType.indexOf('application/json') !== -1) {
		try {
			return r.json()
		} catch (e) {
			throw e
		}
	}
	return null
}
